import styled from "styled-components";
import { colors } from "../../../utils/styled/_variables.styled";
import { InputProps } from "./SelectField.types";

export const FieldWrapper = styled.div`
  .input__wrapper {
    position: relative;
    width: 100%;
  }

  svg {
    position: absolute;
    height: 24px;
    width: 24px;
    right: 12px;
    top: calc(50% - 12px);
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 16px;
  color: ${colors.gray1};
`;

export const Select = styled.select<InputProps>`
  padding: 12px 16px;
  font-size: 16px;
  border: 2px solid
    ${(props) => (props.$borderColor ? colors.red : colors.gray3)};
  border-radius: 8px;
  box-sizing: border-box;
  color: ${(props) => (props.$borderColor ? colors.red : colors.gray1)};
  width: 100%;

  &::placeholder {
    color: ${colors.gray4};
  }

  -moz-appearance: none;
  -webkit-appearance: none; 
  appearance: none;

  &:focus {
    border-color: #007bff;
    outline: none;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }

  &:disabled{
    background-color: ${colors.gray3};
  }
`;

export const ErrorMessage = styled.p`
  font-size: 16px;
  color: ${colors.red};
`;

export const Description = styled.p`
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  color: ${colors.gray2};
  margin-top: 4px;
`;
